import { gql, useQuery } from "@apollo/client";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Typography } from "@mui/material";
import {
  addDays,
  addHours,
  addMinutes,
  differenceInDays,
  differenceInMinutes,
  eachMinuteOfInterval,
  endOfDay,
  format,
  getHours,
  getMinutes,
  getMonth,
  getYear,
  isAfter,
  isBefore,
  isSameDay,
  isSameHour,
  isSameMinute,
  isWithinInterval,
  parse,
  parseISO,
  set,
  startOfDay,
  subDays,
  subHours,
} from "date-fns";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/MiniCalendar.css";
import HourFormat from "../../util/hourFormat";
import Error from "../Error";
import {
  getBookings,
  getCompanyHours,
  getOverrideGroups,
  getOverrides,
} from "../../graphql/querys";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import { Timezones_List } from "../../util/timezones";
import { getDate } from "date-fns";
const Times = (props) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const { loading, error, data, refetch } = useQuery(getCompanyHours, {
    variables: {
      userId: parseInt(props.currentUser.id), // Replace with the user ID you want to filter by
      hours24: HourFormat(),
      sorted: true,
    },
  });
  const {
    loading: overrideGroupLoading,
    error: overrideGroupError,
    data: overrideGroupData,
    refetch: overrideGroupRefetch,
  } = useQuery(getOverrideGroups, {
    variables: {
      userId: parseInt(props.currentUser.id), // Replace with the user ID you want to filter by
    },
  });
  const {
    loading: bookloading,
    error: bookerror,
    data: bookdata,
  } = useQuery(getBookings);
  const {
    loading: overrideLoading,
    error: overrideError,
    data: overrideData,
    refetch: overrideRefetch,
  } = useQuery(getOverrides, {
    variables: {
      userId: parseInt(props.currentUser.id), // Replace with the user ID you want to filter by
    },
  });
  var theOne = overrideGroupData?.getOverrideGroups.find((val) => {
    return (
      isSameDay(new Date(props.selectedDate), new Date(val.date)) &&
      val.groupId == props.data.groupId
    );
  });
  var find = theOne
    ? overrideData?.getOverrides
        .filter((val) => val.groupId == theOne.id)
        .map((val) => {
          return {
            day: format(new Date(theOne.date), "EEEE"),
            groupId: theOne.groupId,
            userId: parseInt(props.currentUser.id),
            startTime: val.startTime,
            endTime: val.endTime,
            id: val.id,
            onJob: true,
          };
        })
    : data?.getCompanyHours.filter(
        (obj) =>
          obj.day === format(props.selectedDate, "EEEE") &&
          props.data.groupId == obj.groupId
      ) || {};
  function getData(date) {
    var theOne = overrideGroupData?.getOverrideGroups.find((val) => {
      return (
        isSameDay(new Date(date), new Date(val.date)) &&
        val.groupId == props.data.groupId
      );
    });
    return theOne
      ? overrideData?.getOverrides
          .filter((val) => val.groupId == theOne.id)
          .map((val) => {
            return {
              day: format(new Date(theOne.date), "EEEE"),
              groupId: theOne.groupId,
              userId: parseInt(props.currentUser.id),
              startTime: val.startTime,
              endTime: val.endTime,
              id: val.id,
              onJob: true,
            };
          })
      : data?.getCompanyHours.filter(
          (obj) =>
            obj.day === format(date, "EEEE") &&
            props.data.groupId == obj.groupId
        ) || {};
  }
  function getTimezoneInfo(timezone) {
    return Timezones_List.find((val) => val.id == timezone);
  }

  useEffect(() => {
    if (!overrideGroupLoading && !loading && !bookloading && !overrideLoading) {
      theOne = overrideGroupData?.getOverrideGroups.find((val) => {
        return (
          isSameDay(new Date(props.selectedDate), new Date(val.date)) &&
          val.groupId == props.data.groupId
        );
      });
      find = theOne
        ? overrideData?.getOverrides
            .filter((val) => val.groupId == theOne.id)
            .map((val) => {
              return {
                day: format(new Date(theOne.date), "EEEE"),
                groupId: theOne.groupId,
                userId: props.currentUser.id,
                startTime: val.startTime,
                endTime: val.endTime,
                id: val.id,
                onJob: true,
              };
            })
        : data?.getCompanyHours.filter(
            (obj) =>
              obj.day === format(props.selectedDate, "EEEE") &&
              props.data.groupId == obj.groupId
          ) || {};
      find = find.filter(
        (date, index, self) =>
          index ==
          self.findIndex(
            (t) =>
              t.startTime.toLowerCase() == date.startTime.toLowerCase() &&
              t.endTime.toLowerCase() == date.endTime.toLowerCase()
          )
      );
      let tempTimesyest = [];
      let tempTimes = [];
      let tempTimestmrw = [];
      var isDateGoods = [
        props.isDateGood(new Date(props.selectedDate)),
        props.isDateGood(new Date(subDays(props.selectedDate, 1))),
        props.isDateGood(new Date(addDays(props.selectedDate, 1))),
      ];
      if (isDateGoods[0] == true) {
        for (let i = 0; i < find.length; i++) {
          findTimes(
            tempTimes,
            find[i].startTime,
            find[i].endTime,
            props.selectedDate
          );
        }
      }
      if (isDateGoods[1] == true) {
        for (
          let i = 0;
          i < getData(subDays(props.selectedDate, 1)).length;
          i++
        ) {
          var dataa = getData(subDays(props.selectedDate, 1));
          tempTimesyest = findTimes(
            tempTimesyest,
            dataa[i].startTime,
            dataa[i].endTime,
            subDays(props.selectedDate, 1),
            1
          );
        }
      }

      if (isDateGoods[2] == true) {
        for (
          let i = 0;
          i < getData(addDays(props.selectedDate, 1)).length;
          i++
        ) {
          var dataa = getData(addDays(props.selectedDate, 1));
          tempTimestmrw = findTimes(
            tempTimestmrw,
            dataa[i].startTime,
            dataa[i].endTime,
            addDays(props.selectedDate, 1),
            1
          );
        }
       }
      // console.log({
      //   today: isDateGoods[0],
      //   yesterday: isDateGoods[1],
      //   tmrw: isDateGoods[2],
      // });
      tempTimesyest.map((val) =>
        tempTimes.push(
          format(
            parse(
              val,
              val.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
              new Date()
            ),
            "h:mmaa"
          ).toLowerCase()
        )
      );
      tempTimestmrw.map((val) =>
        tempTimes.push(
          format(
            parse(
              val,
              val.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
              new Date()
            ),
            "h:mmaa"
          ).toLowerCase()
        )
      );
      setTimes(
        [...new Set(tempTimes)].map((val) =>
          format(parse(val, "h:mmaa", new Date()), HourFormat()).toLowerCase()
        )
      );
    }
  }, [
    loading,
    props.selectedDate,
    overrideGroupLoading,
    overrideLoading,
    bookloading,
  ]);
  const [times, setTimes] = useState([]);
  if (loading || bookloading || overrideGroupLoading || overrideLoading) {
    return "Loading...";
  } else {
  }
  if (error || bookerror || overrideGroupError || overrideError) {
    return <Error />;
  }

  function findit(e, fornows) {
    var count = 0;
    for (let i = 0; i < fornows.length; i++) {
      if (
        new Date(fornows[i].time).getFullYear() == e.getFullYear() &&
        new Date(fornows[i].time).getDate() == e.getDate() &&
        new Date(fornows[i].time).getHours() == e.getHours() &&
        new Date(fornows[i].time).getMinutes() == e.getMinutes()
      ) {
        count++;
      }
    }
    return count
      ? props.data?.maxInvitees
        ? props.data?.maxInvitees - count <= 0
          ? false
          : props.data?.maxInvitees - count
        : count
      : false;
  }
  function checks(time, selectedDate) {
    var actualTime = new Date(selectedDate || props.selectedDate).setHours(
      parse(
        time,
        HourFormat(),
        new Date(selectedDate || props.selectedDate)
      ).getHours(),
      parse(
        time,
        HourFormat(),
        new Date(selectedDate || props.selectedDate)
      ).getMinutes()
    );
    actualTime = new Date(actualTime);
    var fornows = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
          new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        new Date(actualTime).getHours() === new Date(obj.time).getHours() &&
        new Date(actualTime).getMinutes() === new Date(obj.time).getMinutes() &&
        obj.eventId == props.data?.id
    );
    var fornows2 = bookdata.getBookings.filter(
      (obj) =>
        new Date(actualTime).getFullYear() ===
          new Date(obj.time).getFullYear() &&
        new Date(actualTime).getDate() === new Date(obj.time).getDate() &&
        obj.eventId == props.data?.id
    );
    if (
      props.data?.eventsPerDay !== null &&
      fornows2?.length &&
      props.data?.eventsPerDay == fornows2?.length
    ) {
      return "late";
    }
    if (
      differenceInMinutes(parse(time, HourFormat(), new Date()), new Date()) <
        0 &&
      isSameDay(new Date(), new Date(selectedDate || props.selectedDate))
    ) {
      return "late";
    }
    if (fornows.length == 0) {
      return props.data?.maxInvitees ? props.data?.maxInvitees : true;
    }
    return props.data?.eventType == "group"
      ? findit(actualTime, fornows)
      : "one";
  }
  function getTimezoneInfo(timezone) {
    return Timezones_List.find((val) => val.id == timezone);
  }
  function getTimezoneOffset(timezone) {
    const now = new Date();

    // Get the offset in minutes
    const offset =
      new Date().getTimezoneOffset() -
      new Date(
        new Intl.DateTimeFormat("en-US", {
          timeZone: timezone,
          hourCycle: "h23",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(now)
      ).getTimezoneOffset();

    // Format the offset
    const sign = offset < 0 ? "-" : "+";
    const hours = Math.abs(Math.floor(offset / 60))
      .toString()
      .padStart(2, "0");
    const minutes = Math.abs(offset % 60)
      .toString()
      .padStart(2, "0");

    return `${sign}${hours}${minutes}`;
  }
  function toUtc(date, timezone) {
    // Create a date object with the desired timezone
    let dateObj = new Date(date + " " + timezone);

    // Get the timezone offset in minutes
    let timezoneOffset = dateObj.getTimezoneOffset();

    // Convert the timezone offset from minutes to milliseconds
    let offsetMillis = timezoneOffset * 60 * 1000;

    // Get the UTC date by subtracting the timezone offset
    let utcDate = new Date(dateObj.getTime() - offsetMillis);
    return utcDate;
  }

  function findTimes(arr, start, end, selectedDate, spilled) {
    if (!start || !end) {
      return false;
    }
    var startTime = parse(
      start,
      start.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      selectedDate
    );
    var endTime = parse(
      end,
      end.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      selectedDate
    );
    if (isBefore(endTime, startTime)) {
      endTime = addDays(endTime, 1);
    }

    const timestamps = eachMinuteOfInterval({
      start: startTime,
      end: endTime,
    });
    var thirtyMinuteIntervals = timestamps.filter((time, index) => {
      return (
        isWithinInterval(new Date(addMinutes(time, props.data?.length)), {
          start: startTime,
          end: endTime,
        }) && index % props.data?.increments === 0
      );
    });
    function convertToUserTime(time, userTimeZone) {
      // convert the time (which is in the company's timezone) to UTC
      const utcTime = toUtc(
        time,
        getTimezoneOffset(getTimezoneInfo(props.currentUser.timezone).timezone)
      );

      // convert the UTC time to the user's timezone
      const userTime = utcToZonedTime(utcTime, userTimeZone);

      return userTime;
    }
    function isTimeWithinSelectedDay(time) {
      return (
        (isAfter(time, startOfDay(new Date(selectedDate))) &&
          isBefore(time, endOfDay(new Date(selectedDate)))) ||
        isSameDay(time, startOfDay(new Date(selectedDate)))
      );
    }
    var spilledTimes = [];
    thirtyMinuteIntervals = thirtyMinuteIntervals.filter(
      (date, index, self) =>
        index ==
        self.findIndex((t) => isSameHour(t, date) && isSameMinute(t, date))
    );
    thirtyMinuteIntervals.forEach((time) => {
      // Create a new date object in the company's timezone
      const timeInCompanyTimezone = zonedTimeToUtc(
        format(time, "yyyy-MM-dd HH:mm:ss"),
        getTimezoneInfo(props.currentUser.timezone).timezone
      );

      // Then, you can convert this time to the user's timezone
      const formattedTime = format(
        new Date(timeInCompanyTimezone),
        HourFormat()
      );
      if (
        checks(formattedTime, selectedDate) !== "late" &&
        checks(formattedTime, selectedDate) !== "one"
      ) {
        if (isTimeWithinSelectedDay(timeInCompanyTimezone)) {
          arr.push(format(timeInCompanyTimezone, "h:mmaa"));
        } else {
          spilledTimes.push(format(timeInCompanyTimezone, "h:mmaa"));
        }
      }
    });
    if (spilled) {
      return spilledTimes;
    }
  }
  function getTime(time){
if((props.decodedToken?.calendar||props.calendar)=="Ethiopian"){
  var vartime=new Date(subHours(parse(time,time.includes("m")?"hh:mmaa":"HH:mm",new Date()),6))
  if(vartime.getHours()<6){
    return "ከጥዋቱ "+format(vartime,"hh:mm")
  } else if(vartime.getHours()<12){
    return "ከቀኑ "+format(vartime,"hh:mm")
  }else if(vartime.getHours()<18){
    return "ከምሽቱ "+format(vartime,"hh:mm")
  }else if(vartime.getHours()<24){
    return "ከሌሊቱ "+format(vartime,"hh:mm")
  }
}else{
return time
}
  }
  function convertToDate(time, date) {
    return parse(
      time,
      time.toLowerCase().includes("m") ? "h:mmaa" : "HH:mm",
      date
    );
  }
  return (
    <div className={"calendar-container times " + props.smallScreen}>
      {props.noDate ? "" : format(props.selectedDate, "EEEE, MMMM d")}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
          overflowX: "hidden",
          height: !props.smallScreen && props.height,
          maxWidth: "100%",
        }}
      >
        {times.length ? (
          times.map((val, i) => (
            <div
              className="timeCon"
              style={{
                display: "flex",
                minHeight: "70px",
                alignItems: "center",
                maxWidth: !props.smallScreen && "90%",
                justifyContent: "space-between",
              }}
            >
              <div
                className={`timeOption blue ${checks(val) ? "" : "disablede"}`}
                style={{
                  width: selectedTime == val ? "47%" : "100%",
                  display: "flex",
                  gap: "2%",
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "4px",
                }}
                onClick={(e) => {
                  checks(val) ? setSelectedTime(val) : console.log("");
                }}
              >
                <h3 style={{ margin: 0,textAlign:'center' }}>{getTime(val)}</h3>
                {checks(val) !== true ? (
                  <h5
                    style={{
                      margin: 0,
                      textAlign:'center',
                      display: props.data?.showRemaining ? "flex" : "none",
                    }}
                  >
                    {(checks(val) > 99 ? "99+" : checks(val) || 0) +
                      " slots left"}
                  </h5>
                ) : (
                  ""
                )}
              </div>
              <a
                href={`/${props.currentUser.url}/events/${
                  props.link
                }/${new Date(
                  convertToDate(val, props.selectedDate)
                ).toISOString()}`}
                className="timeOption green"
                style={{
                  borderColor: "lightgreen",
                  textDecoration: "none",
                  color: "#32de84",
                  width: selectedTime == val ? "47%" : "100%",
                  display: selectedTime == val ? "flex" : "none",
                }}
              >
                Confirm
              </a>
            </div>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: props.height,
              maxWidth: "100%",
            }}
          >
            <Typography>No Available Times</Typography>
          </div>
        )}
      </div>
    </div>
  );
};
export default Times;
